module.exports = __webpack_public_path__ + "img/Thomas.428bad3e.jpg";